import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from '../api/axiosConfig';
import useTicketId from '../hooks/useTicketId';
import { API_ENDPOINTS, PARAMS } from '../api/axiosConfig';

export default function TicketEntry() {
  const ticketIdFromHook = useTicketId();
  const [ticketId, setTicketId] = useState(ticketIdFromHook);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await api.get(API_ENDPOINTS.TICKET_VALIDITY, { 
        params: { [PARAMS.TICKET_ID]: ticketId }
      });
      const data = res.data;
      if (data === true || data.valid === true) {
        navigate(`/upload?ticketId=${ticketId}`);
      } else {
        setError("Invalid or expired ticket. Please try again.");
      }
    } catch {
      setError("Error validating ticket. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <div className="header">
          <h1>Enter Your Ticket ID</h1>
        </div>
        <form onSubmit={handleSubmit} className="content">
          <input
            type="text"
            value={ticketId}
            onChange={e => setTicketId(e.target.value)}
            placeholder="Enter ticket ID"
            required
            aria-label="Ticket ID"
            style={{ padding: "0.5rem", fontSize: "1rem", width: "100%", marginBottom: "1rem" }}
            disabled={loading}
          />
          <button type="submit" className="submit-btn" disabled={loading || !ticketId}>
            {loading ? <span className="btn-loader" /> : "Proceed to Upload"}
          </button>
          {error && (
            <div className="status-message error" style={{ marginTop: "1rem", color: "red" }}>
              {error}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
